import CookieLaw from 'vue-cookie-law';
import Vue from 'vue';
import vueResource from 'vue-resource'

import modal from './elements/Modal.vue';

import { eventBus } from './eventBus.js';
import guide from './components/Guide.vue';
import homepage from './components/Homepage.vue';
import myPlan from './components/MyPlan.vue';
import navigation from './components/Navigation.vue';
import subscription from './components/Subscription.vue';
import updateCard from './components/UpdateCard.vue';



/*
 * Helpers
 */
String.prototype.nl2br = function () {
    return this.replace(/(?:\r\n|\r|\n)/g, '<br />');
};

String.prototype.urlify = function (separator = '-') {
    let value = this;

    value = value.replace('\'', '').replace('`', ''); // remove quotes
    value = value.replace(/[\W_]+/g, separator); // replace non-alphanumeric chars with separator
    value = value.replace(new RegExp('^' + separator + '+|' + separator + '+$', 'g'), ''); // trim extra separators
    value = value.toLowerCase(); // convert to lowercase

    return value;
};



Vue.use(vueResource);

Vue.http.interceptors.push(function(request, next) {
    request.headers.set('Authorization', 'Bearer ' + process.env.MIX_ACCESS_TOKEN);
    next();
});

Vue.mixin({
    computed: {
        user: function () {
            return JSON.parse(window.user);
        }
    }
});

const app = new Vue({
    el: '#app',
    components: {
        CookieLaw,
        guide,
        modal,
        homepage,
        myPlan,
        navigation,
        subscription,
        updateCard
    },
    created: function() {
        // attach event listeners
        eventBus.$on('hide-loader', this.hideLoader);
        eventBus.$on('show-loader', this.showLoader);
    },
    data: {
        homepageNavOpen: false,
        isNavigationActive: false,
        loader: 0
    },
    methods: {
        hideLoader: function () {
            this.loader--;
        },
        homepageNavToggle: function () {
            this.homepageNavOpen = !this.homepageNavOpen;
        },
        openModal: function (id) {
            eventBus.$emit('open-modal', id);
        },
        showLoader: function (e) {
            this.loader++;
        },
        toggleNavigation: function () {
            this.isNavigationActive = !this.isNavigationActive;

            if (this.isNavigationActive) {
                document.querySelector('html, body').classList.add('has-no-scroll');
            } else {
                document.querySelector('html, body').classList.remove('has-no-scroll');
            }
        }
    }
});



/*
 * Alerts
 */
if (document.querySelector('.alert') != null) {
    document.querySelectorAll('.alert').forEach(function (alert) {
        setTimeout(function() {
            closeAlert(alert);
        }, 5000);

        alert.querySelector('.alert__close').addEventListener('click', function () {
            closeAlert(alert);
        })
    });

    function closeAlert(alert) {
        alert.classList.add('is-hiding');
        setTimeout(function() {
            alert.remove();
        }.bind(this), 450);
    }
}